/**
 * Created by renatolovizotto on 17/07/17.
 */
import {observable, action} from 'mobx';

class PlayerStore {

    @observable isLoading = false;
    @observable bookHTML = '';

    @action
    async loadBookHTML() {

        this.isLoading = true;

        return await fetch('https://en.wikipedia.org/wiki/Curitiba')
            .then(
                response => response.text()
            )
            .then(
                response => {
                    this.isLoading = false;
                    this.bookHTML = response;
                }
            )
    }
}

export default new PlayerStore();


// WEBPACK FOOTER //
// ./src/stores/PlayerStore.js